<template>
  <span ref="trigger">
    <slot></slot>
    <transition :name="effect">
      <div ref="popover" v-if="show" :class="['popover',placement]">
        <div class="arrow"></div>
        <h3 class="popover-title" v-if="title"><slot name="title">{{title}}</slot></h3>
        <div class="popover-content" v-if="content">
            <slot name="content">
                <span v-html="content"></span>
                <hr style="margin: 10px 0px 15px 0px;">
                <input-w v-model="dataModel" :validation="validation" :aIconStyle="{right: '40px'}"
                @validateResult="checkValidateResult" :validateOnValueChange="true">
                    <input type="number" :placeholder="placeholder" v-model="dataModel" style="width: 90%;">
                </input-w>
            </slot>
        </div>
        <div>
            <button class="btn btn-danger btn-sm" style="float: left; margin: 5px" @click="cancel">Cancel</button>
            <button class="btn btn-primary-default btn-sm" style="float: right; margin: 5px" @click="apply" :disabled="invalid">Apply</button>
        </div>  
      </div>
    </transition>
  </span>
</template>

<script>
import PopoverMixin from './utils/popoverMixins.js'
import InputW from '../inputWrapper/inputWrapper.vue'

export default {
  mixins: [PopoverMixin],
  props: {
    trigger: {
        type: String, 
        default: 'click'
    },
    title: String,
    content: String,
    value: Number,
    validation: String,
    placeholder: String
  },
  components: {
    InputW
  },
  data: function(){
      return {
          popoverCondition: true,
          dataModel: null,
          invalid: true
      }
  },
  mounted: function(){
      this.dataModel = this.value;
  },
  watch: {
      value: function(){
          this.dataModel = this.value;
      }
  },
  methods: {
      close: function(){
          this.toggle();
      },
      cancel: function(){
          this.dataModel = this.value;
          this.close();
      },
      apply: function(){
          this.$emit("confirm", this.dataModel);
          this.close();
      },
      checkValidateResult: function($event){
          this.invalid = !$event.result;
      }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/dynamic/popoverWrapper/NumberModifier.vue?6748e996